import React from "react";
import { EditIcon } from "@bale/ui";
import styles from "./ImageInputPreview.module.scss";
import { useTheme } from "@emotion/react";
import { strings } from "intl/fa";

interface Props {
  imageFileURL?: string;
  onEdit?: () => void;
  label?: string;
}

const ImageURLPreview: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const theme = useTheme();
  return (
    <div className={styles.Container}>
      <div className={styles.Label}>
        {props.label ?? strings.common.input.image.label}
      </div>
      <div className={styles.EditIconContainer}>
        <div className={styles.EditIconWrapper} onClick={props.onEdit}>
          <EditIcon size={16} color={theme.colors.light.on_primary} />
        </div>
      </div>
      <div className={styles.FileInfo}>
        <span className={styles.FileName}>image.jpeg</span>
      </div>
      <img
        className={styles.Img}
        src={props.imageFileURL}
        alt="image_preview"
      />
    </div>
  );
};

export default ImageURLPreview;
